import {
  type QueryFunctionContext,
  type QueryObserverOptions,
  useQuery
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { agentsQueryKeys } from 'queries/agents/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

import type { AxiosError } from 'axios'
import type { AgentSummaryResponse } from 'types/api/agents/agents'

function fetchAgentsSummary({
  queryKey: [endpoint, params]
}: QueryFunctionContext<ReturnType<typeof agentsQueryKeys.getSummary>>) {
  const endpointWithParams = getEndpointWithParams(endpoint, params)

  return fetchQueryData<AgentSummaryResponse>(endpointWithParams, {})
}

export const useGetAgentsSummary = (
  options?: Omit<
    QueryObserverOptions<AgentSummaryResponse, AxiosError>,
    'queryFn' | 'queryKey'
  >
) => {
  const { currentTeamId: teamId } = useAuth()

  return useQuery<AgentSummaryResponse, AxiosError>({
    ...options,
    queryKey: agentsQueryKeys.getSummary({ teamId }),
    queryFn: fetchAgentsSummary
  })
}
